"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const plugin = require("./plugin.cjs");
exports.EventClient = plugin.EventClient;
//# sourceMappingURL=index.cjs.map
